import { render, staticRenderFns } from "./siparis.vue?vue&type=template&id=078ee532"
import script from "./siparis.vue?vue&type=script&lang=js"
export * from "./siparis.vue?vue&type=script&lang=js"
import style0 from "./siparis.vue?vue&type=style&index=0&id=078ee532&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports